// extracted by mini-css-extract-plugin
export var discard = "_48-3";
export var muiTooltipTooltip = "_48-5";
export var notificationBar = "_48-2";
export var saveButtonHoverSlotWrapper = "_48-4";
export var show = "_48-1";
export var spacer = "_48-0";